import Vue from 'vue';
import Router from 'vue-router';

import PrvDirectProduct from '@/views/PrvDirectProduct.vue';

Vue.use(Router);

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,

  routes : [
    {
      path: '/prv-direct-product',
      name: 'prv-direct-product',
      component: PrvDirectProduct
    },

  ]
});

export default router;
